import { render } from "./overlay.vue?vue&type=template&id=4a975eef"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import "./overlay.vue?vue&type=style&index=0&id=4a975eef&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__